import {config} from "./config"
import Cookie from "./Cookie"

const api = {

    auth: {

        login: async (name, password) => {
            const response = await fetch(`${config.restApiHost}/login`, {
                method: "POST",
                headers: {"Content-Type": "application/json;charset=UTF-8"},
                body: JSON.stringify({name, password}),
            })
            let json = await response.json()
            if (response.status === 200) {
                return json
            } else {
                throw new Error(json.message)
            }
        },
    
        restorePassword: async (user_name) => {
            const response = await fetch(`${config.restApiHost}/user/restorePassword?name=${user_name}`, {"method": "GET"})
            let json = await response.json()
            if (response.status === 200) {
                return json
            } else {
                throw new Error(json.message)
            }
        },

    },

    inventory: {

        /**
         * Получить предмет инвентаря
         * 
         * @param {Number} item_id 
         * @return {item}
         */

        get: async (item_id) => {
            const response = await fetch(`${config.restApiHost}/inventory/item/${item_id}?sid=${Cookie.get("sid")}`, {"method": "GET"})
            let json = await response.json()
            if (response.status === 200) {
                return json
            } else {
                throw new Error(json.message)
            }
        },

        /**
         * Получить список предметов инвентаря.
         * 
         * @param search - строка поиска.
         * @param filter - фильтр.
         * @param filter_shops - фильтра магазинов.
         * @return {items}
         */

        list: async (search, filter, filter_shops) => {
            let _filter = filter ? "&filter=" + encodeURIComponent(filter.map(item => item.id).join(",")) : ""
            let _search = search ? `&search=${encodeURIComponent(search)}` : ""
            let _filter_shops = filter_shops ? "&filter_shops=" + encodeURIComponent(filter_shops.map(shop => shop.id).join(",")) : ""
            const response = await fetch(`${config.restApiHost}/inventory/items?sid=${Cookie.get("sid")}${_search}${_filter}${_filter_shops}`, { method: "GET" })
            let json = await response.json()
            if (response.status === 200) {
                return json
            } else {
                throw new Error(json.message)
            }            
        },

        image: {

            /**
             * Прикрепить изображение к предмету.
             * 
             * @param {Number} item_id - id предмета.
             * @param {String} filename - имя файла изображения.
             * @response {Number} image_id - id прикрепленного изображения.
             */

            attach: async (item_id, filename) => {

                const response = await fetch(
                    `${config.restApiHost}/inventory/item/${item_id}/image?sid=${Cookie.get("sid")}`, 
                    {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            filename,
                        }),
                    }
                )
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось прикрепить изображение к предмету с id = ${item_id}.`)

            },

            /**
             * Открепить изображение от предмета.
             * 
             * @param {Number} image_id - id изображения. 
             */

            detach: async (image_id) => {

                const response = await fetch(
                    `${config.restApiHost}/inventory/item/image/${image_id}?sid=${Cookie.get("sid")}`,
                    {
                        method: "DELETE"
                    }
                )
                if (response.status === 200) {
                    return await response.json()
                } else {
                    throw new Error(`Не удалось открепить изображение.`)
                }

            },

            /**
             * Получить список прикрепленных изображений.
             * 
             * @param {Number} item_id - id предмета.
             * @response {Array} items - список предметов.
             */

            list: async (item_id) => {

                const response = await fetch(
                    `${config.restApiHost}/inventory/item/${item_id}/images?sid=${Cookie.get("sid")}`,
                    {
                        method: "GET",
                    }
                )

                let json = await response.json()
                if (response.status == 200) {
                    return json
                } else {
                    throw new Error(`Не удалось получить список изображений для предмета ${item_id}.`)
                }

            },

        },

    },

    users: {

        /**
         * Создать пользователя.
         * 
         * @param {String} name 
         * @param {String} password 
         * @param {String} email 
         * @param {Number} permission
         * 
         * @return response - {id - id пользователя}.
         */

        create: async (name, password, email, permission) => {
            const response = await fetch(`${config.restApiHost}/user?sid=${Cookie.get("sid")}`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({name, password, email, permission}),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать пользователя.`)
        },

        /**
         * Получить пользователя.
         * 
         * @param {Number} user_id 
         * @return - пользователь.
         */

        get: async (user_id) => {
            const response = await fetch(`${config.restApiHost}/user/${user_id}?sid=${Cookie.get("sid")}`, {
                method: "GET",
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать пользователя.`)
        },

        /**
         * Получить список пользователей.
         * 
         * @return - список пользователей.
         */

        list: async () => {
            const response = await fetch(`${config.restApiHost}/users?sid=${Cookie.get("sid")}`, {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить список магазинов.`)
        },

        /**
         * Обновить пользователя.
         * 
         * @param {Number} user_id 
         * @param {String} name 
         * @param {String} password 
         * @param {String} email 
         * @param {Number} permission 
         */

        update: async (user_id, name, password, email, permission) => {
            const response = await fetch(`${config.restApiHost}/user/${user_id}?sid=${Cookie.get("sid")}`, {
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({name, password, email, permission}),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать пользователя.`)
        },

        /**
         * Удалить пользователя.
         * 
         * @param {Number} user_id - id пользователя.
         */

        delete: async (user_id) => {
            const response = await fetch(`${config.restApiHost}/user/${user_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить список магазинов.`)
        },

    },

    shops: {

        /**
         * Создать магазин
         * 
         * @param {String} name - название магазина
         * 
         * @return - {id - id созданного магазина}
         */

        create: async (name) => {
            const response = await fetch(`${config.restApiHost}/shop?sid=${Cookie.get("sid")}`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    name: name,
                }),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить список магазинов.`)
        },

        /**
         * Получить магазин.
         * 
         * @param {Number} shop_id 
         * 
         * @return - {shop - магазин}
         */

        get: async (shop_id) => {
            const response = await fetch(`${config.restApiHost}/shop/${shop_id}?sid=${Cookie.get("sid")}`, {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить магазинов id = ${shop_id}.`)
        },

        /**
         * Обновить магазин.
         * 
         * @param {Number} shop_id - id магазина.
         * @param {String} name - название магазина.
         */

        update: async (shop_id, name) => {
            const response = await fetch(`${config.restApiHost}/shop/${shop_id}?sid=${Cookie.get("sid")}`, {
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    name: name,
                }),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить магазинов id = ${shop_id}.`)
        },

        /**
         * Получить список магазинов.
         * 
         * @return {Promise}
         */
        
        list: async () => {
            const response = await fetch(`${config.restApiHost}/shops?sid=${Cookie.get("sid")}`, {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить список магазинов.`)
        },

        /**
         * Получить список магазинов.
         * 
         * @return {Promise}
         */
        
        delete: async (shop_id) => {
            const response = await fetch(`${config.restApiHost}/shop/${shop_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось удалить магазин id = ${shop_id}.`)
        },

    },

    purchases: {

        /**
         * Создать закупку.
         * 
         * @param {String} name 
         * 
         * @return response - ответ. Содержит поле с id созданной закупки.
         */

        create: async (name) => {
            const response = await fetch(`${config.restApiHost}/purchase?sid=${Cookie.get("sid")}`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    name: name,
                }),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать закупку.`)
        },

        /**
         * Получить закупку по id.
         * 
         * @param {Number} purchase_id - id закупки.
         * 
         * @return {Promise}
         */

        get: async (purchase_id) => {
            const response = await fetch(`${config.restApiHost}/purchase/${purchase_id}?sid=${Cookie.get("sid")}`, {method: "GET"})
            if (response.status === 200) {
                return await response.json()
            } else {
                throw new Error(`Закупка id = ${purchase_id} не найдена.`)
            }
        },

        /**
         * Обновить данные закупки.
         * 
         * @param {Number} purchase_id - id закупки.
         * @param {String} name - имя закупки.
         * @param {Number} status - статус выполнения.
         */

        update: async (purchase_id, name, status) => {
            const response = await fetch(`${config.restApiHost}/purchase/${purchase_id}?sid=${Cookie.get("sid")}`, {
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({name, status}),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось обновить закупку id = ${purchase_id}.`)
        },

        /**
         * Обновить статус закупки.
         * 
         * @param {Number} purchase_id - id закупки.
         * @param {Number} status - статус выполнения.
         */

        update_status: async (purchase_id, status) => {
            const response = await fetch(`${config.restApiHost}/purchase/${purchase_id}/status?sid=${Cookie.get("sid")}`, {
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({status}),
            })
            if (response.status === 200) return await response.json()
            throw new Error(`Не удалось обновить статус закупки id = ${purchase_id}.`)
        },

        /**
         * Удалить закупку.
         * 
         * @param {Number} purchase_id - id закупки.
         * 
         * @return {Promise}
         */

        delete: async (purchase_id) => {
            const response = await fetch(`${config.restApiHost}/purchase/${purchase_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось удалить закупку id = ${purchase_id}.`)
        },

        /**
         * Получить список закупок.
         * 
         * @return {Promise}
         */

        list: async (orderByDate) => {
            let params = [
                `sid=${Cookie.get("sid")}`
            ]
            if (orderByDate && (orderByDate === "ASC" || orderByDate === "DESC")) {
                params.push(`&orderByDate=${orderByDate}`)
            }
            const response = await fetch(`${config.restApiHost}/purchases?` + params.join("&"), {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось получить список закупок.`)
        },

        attachments: {

            /**
             * Создать вложение для закупки.
             * 
             * @param {*} purchase_id - id закупки.
             * @param {*} item_id - id предмета. 
             * @param {*} quantity - количество предметов.
             * @param {*} shop_id - id магазина.
             * 
             * @return {Promise} - ответ сервера.
             */

            create: async (purchase_id, item_id, quantity, shop_id) => {
                const response = await fetch(`${config.restApiHost}/purchase/${purchase_id}/attachment?sid=${Cookie.get("sid")}`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({item_id, quantity, shop_id}),
                })
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать вложение для закупки id = ${purchase_id}.`)
            },

            /**
             * Получить вложение.
             * 
             * @param attachment_id - id вложения.
             */

            get: async (attachment_id) => {
                const response = await fetch(`${config.restApiHost}/purchase/attachment/${attachment_id}?sid=${Cookie.get("sid")}`, {method: "GET"})
                if (response.status === 200) {
                    return await response.json()
                } else {
                    throw new Error(`Невозможно получить вложение с id = ${attachment_id}`)
                }
            },

            /**
             * Обновить значения для вложения закупки.
             * 
             * @param {Number} attachment_id - id вложения.
             * @param {Number} quantity -  количество предметов.
             * @param {Number} shop_id - id магазина.
             * @param {Number} checked - состояние отметки {0, 1}
             * 
             * @return {Promise}
             */

            update: async (attachment_id, quantity, shop_id, checked) => {
                const response = await fetch(`${config.restApiHost}/purchase/attachment/${attachment_id}?sid=${Cookie.get("sid")}`, {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({quantity, shop_id, checked}),
                })
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось обновить вложение id = ${attachment_id}.`)
            },

            /**
             * Удалить вложение закупки.
             * 
             * @param {Number} attachment_id - id вложения.
             * 
             * @return {Promise}
             */            

            delete: async (attachment_id) => {
                const response = await fetch(`${config.restApiHost}/purchase/attachment/${attachment_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
                if (response.status === 200) {
                    return await response.json()
                } else {
                    throw new Error(`Не удалось удалить вложение id = ${attachment_id}.`)
                }
            },

            /**
             * Установить статус выбрано (checked) для вложения закупки.
             * @param {Number} attachment_id - id вложения.
             * @param {Number} checked - состояние.
             */

            check: async (attachment_id, checked) => {
                const response = await fetch(`${config.restApiHost}/purchase/attachments/${attachment_id}/checked/${checked ? 1 : 0}?sid=${Cookie.get("sid")}`, {method: "PUT"})
                if (response.status === 200) {
                    return await response.json()
                } else {
                    throw new Error(`Не удалось изменить статус выделения для вложения id = ${attachment_id}.`)
                }
            },

        },

    },

    purchases_templates: {

        /**
         * Создать шаблона закупки.
         * 
         * @param {String} name - название шаблона закупки.
         * @param {Number} type - типа шаблона (0 - папка, 1 - шаблон закупки)
         * @param {Number} folder_id - id папки в которой будет находиться шаблона закупки.
         * 
         * @return {Promise} - ответ сервера ({id - id созданного шаблона}).
         */

        create: async (name, type, folder_id) => {
            const response = await fetch(`${config.restApiHost}/purchases/template?sid=${Cookie.get("sid")}`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({name, type, folder_id}),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать ${type ? "шаблона закупки" : "папку"}.`)
        },

        /**
         * Получить шаблона закупки по id.
         * 
         * @param {Number} template_id - id шаблона закупки.
         * @return Promise.resolve(template) - шаблон закупки.
         */

        get: async (template_id) => {
            const response = await fetch(`${config.restApiHost}/purchases/template/${template_id}?sid=${Cookie.get("sid")}`, {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject("Не удалось получить список шаблонов закупок.")
        },

        /**
         * Обновить шаблона закупки.
         * 
         * @param {Number} template_id - id шаблона. 
         * @param (String) name - название шаблона
         */

        update: async (template_id, name) => {
            const response = await fetch(`${config.restApiHost}/purchases/template/${template_id}?sid=${Cookie.get("sid")}`, {
                method: "PUT",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({name}),
            })
            return response.status === 200 ? await response.json() : Promise.reject(`Не удалось обновить шаблона или папку с id = ${template_id}.`)
        },

        /**
         * Удалить шаблон закупки или папку.
         * 
         * @param {Number} template_id - id шаблона закупки или папки.
         * @return Promise
         */

        delete: async (template_id) => {
            const response = await fetch(`${config.restApiHost}/purchases/template/${template_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
            return response.status === 200 ? await response.json() : Promise.reject(`Ну удалось удалить шаблон закупки с id = ${template_id}.`)
        },

        /**
         * Получить список шаблонов закупок.
         * 
         * @param {Number} folder_id - id папки.
         * @return Promise.resolve(purchases_templates_list) - список шаблонов закупок.
         */

        list: async (folder_id) => {
            const response = await fetch(`${config.restApiHost}/purchases/templates/${folder_id}?sid=${Cookie.get("sid")}`, {method: "GET"})
            return response.status === 200 ? await response.json() : Promise.reject("Не удалось получить список шаблонов закупок.")
        },

        /**
         * Перенос шаблона или папки в папку.
         * 
         * @param {Number} template_id 
         * @param {Number} folder_id 
         * 
         * @return {Promise}
         */

        move_to_folder: async (template_id, folder_id) => {
            const response = await fetch(`${config.restApiHost}/purchases/template/${template_id}/move_to_folder/${folder_id}?sid=${Cookie.get("sid")}`, {method: "PUT"})
            return response.status === 200 ? await response.json() : Promise.reject(`Перенос объекта id = ${template_id} в папку id = ${folder_id} ну удался.`)
        },

        attachments: {

            /**
             * Создать вложение для шаблона закупки.
             * 
             * @param {*} template_id - id шаблона закупки.
             * @param {*} item_id - id предмета. 
             * @param {*} quantity - количество предметов.
             * @param {*} shop_id - id магазина.
             * 
             * @return {Promise} - ответ сервера.
             */

            create: async (template_id, item_id, quantity, shop_id) => {
                const response = await fetch(`${config.restApiHost}/purchases/template/${template_id}/attachment?sid=${Cookie.get("sid")}`, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({item_id, quantity, shop_id}),
                })
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось создать вложение для шаблона id = ${template_id}.`)
            },

            /**
             * Обновить значения для вложения шаблона закупок.
             * 
             * @param {Number} attachment_id - id вложения.
             * @param {Number} quantity -  количество предметов.
             * @param {Number} shop_id - id магазина.
             * 
             * @return {Promise}
             */

            update: async (attachment_id, quantity, shop_id) => {
                const response = await fetch(`${config.restApiHost}/purchases/template/attachment/${attachment_id}?sid=${Cookie.get("sid")}`, {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({quantity, shop_id}),
                })
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось обновить вложение id = ${attachment_id}.`)
            },

            /**
             * Удалить вложение шаблона закупок.
             * 
             * @param {Number} attachment_id - id вложения.
             * 
             * @return {Promise}
             */            

            delete: async (attachment_id) => {
                const response = await fetch(`${config.restApiHost}/purchases/template/attachment/${attachment_id}?sid=${Cookie.get("sid")}`, {method: "DELETE"})
                return response.status === 200 ? await response.json() : Promise.reject(`Не удалось удалить вложение id = ${attachment_id}.`)
            },

        },

    },

    shows: {

        create: async (show) => {
            let response = await fetch(
                `${config.restApiHost}/show?sid=${Cookie.get("sid")}`,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(show),
                },
            )
            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список шаблонов.`)
            }
        },  

        /**
         * Получить список шоу.
         * 
         * @return 
         */

        list: async (filter, search, order_by_date) => {
            let req = `${config.restApiHost}/shows?sid=${Cookie.get("sid")}`
            if (filter) {
                req += `&filter=${encodeURIComponent(filter)}`
            }
            if (search) {
                req += `&search=${encodeURIComponent(search)}`
            }
            if (order_by_date) {
                req += `&orderByDate=${encodeURIComponent(order_by_date)}`
            }
            const response = await fetch(req, {method: "GET"})
            let json = await response.json()
            if (response.status === 200) {
                return json
            } else {
                throw new Error(json.message)
            }
        },

        attachments: {

            /**
             * Получить список вложений для шоу.
             * 
             * @param {Number} show_id - id шоу.
             */

            list: async (show_id) => {
                const response = await fetch(`${config.restApiHost}/show/${show_id}/attachments?sid=${Cookie.get("sid")}`, {method: "GET"})
                let json = await response.json()
                if (response.status === 200) {
                    return json
                } else {
                    throw new Error(json.message)
                }                
            }

        },

    },

    templates: {

        /**
         * Создать шаблон.
         * 
         * @param {String} name - имя шаблона.
         * @param {Number} type - тип шаблона (0 - папка, 1 - шаблон).
         * @param {Number} folder_id - id папки в которой должен находится шаблон.
         */

        create: async (name, type, folder_id) => {
            let response = await fetch(
                `${config.restApiHost}/show/template?sid=${Cookie.get("sid")}`,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ name, type, folder_id }),
                }
            )
            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось создать шаблон ${name}.`)
            }
        },

        /**
         * Получить список шаблонов.
         */

        list: async () => {
            const response = await fetch(`${config.restApiHost}/show/templates?sid=${Cookie.get("sid")}`, { method: "GET" })
            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список шаблонов.`)
            }
        },

        attachments: {

            /**
             * 
             * @param {Number} template_id - id шаблона шоу.
             * @param {Number} item_id - id предмета.
             * @param {Number} amount - количество предметов.
             * @param {Number} repeat - 
             * @param {Number} order -
             */

            create: async (template_id, item_id, amount, repeat) => {
                const response = await fetch(
                    `${config.restApiHost}/show/template/${template_id}/attachment?sid=${Cookie.get("sid")}`,
                    {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({ item_id, amount, repeat }),
                    }
                )
                let json = await response.json()
                if (response.status == 200) {
                    return json
                } else {
                    throw new Error(`Не удалось получить список шаблонов.`)
                }
            },

        },

        /**
         * Получить вложения для шаблона шоу.
         * 
         * @param {Number} template_id - id шаблона.
         */

        get_template_items: async (template_id) => {
            const response = await fetch(`${config.restApiHost}/show/template/${template_id}/items?sid=${Cookie.get("sid")}`, {method: "GET"})
            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список вложений для шаблона ${template_id}.`)
            }
        },

    },

    boxes: {

        /**
         * Получить коробку по id.
         * 
         * @param {Number} id - id коробки.
         */

        get: async (id) => {

            let response = await fetch(
                `${config.restApiHost}/box/${id}}?sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )

            let json = await response.json()

            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось создать коробку.`)
            }

        },

        /**
         * Получить коду коробки.
         * 
         * @param {String} code - код коробки.
         */

        get_byCode: async (code) => {

            let response = await fetch(
                `${config.restApiHost}/box/code?code=${encodeURIComponent(code)}&sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )

            let json = await response.json()

            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось создать коробку.`)
            }

        },        

        /**
         * Создать коробку.
         * 
         * @param {String} code - код коробки.
         */

        create: async (code) => {

            let response = await fetch(
                `${config.restApiHost}/box?sid=${Cookie.get("sid")}`,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ code }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось создать коробку.`)
            }
            
        },

        /**
         * Изменить коробку.
         * 
         * @param {Number} box_id - id коробки.
         * @param {String} code - код коробки.
         */

        update_code: async (box_id, code) => {

            let response = await fetch(
                `${config.restApiHost}/box/${box_id}/code?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ code }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить данные коробки id = ${box_id}.`)
            }

        },

        /**
         * Удалить коробку.
         * 
         * @param {Number} box_id - id коробки.
         */

        delete: async (box_id) => {

            let response = await fetch(
                `${config.restApiHost}/box/${box_id}?sid=${Cookie.get("sid")}`,
                {
                    method: "DELETE",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось удалить коробку id = ${box_id}.`)
            }

        },

        /**
         * Получить список коробок.
         */

        list: async () => {

            let response = await fetch(
                `${config.restApiHost}/boxes?sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )            

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список коробок.`)
            }

        },

    },

    dewars: {

        /**
         * Создать сосуд Дьюара.
         * 
         * @param {String} code - код сосуда Дьюара.
         */

        create: async (code) => {

            let response = await fetch(
                `${config.restApiHost}/dewar?sid=${Cookie.get("sid")}`,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ code }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось создать сосуд Дьюара.`)
            }
            
        },

        get: async (id) => {
            let response = await fetch(
                `${config.restApiHost}/dewar/${id}?sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось найти сосуд Дьюара с id = ${id}.`)
            }
        },

        find: async (code) => {
            
            let response = await fetch(
                `${config.restApiHost}/dewars/find?code=${encodeURIComponent(code)}&sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Непредвиденная ошибка. Не связанна с поиском кода сосуда Дьюара.`)
            }

        },

        /**
         * Изменить сосуд Дьюара.
         * 
         * @param {Number} dewar_id - id сосуда Дьюара.
         * @param {String} code - код сосуда Дьюара.
         */

        update_code: async (dewar_id, code) => {

            let response = await fetch(
                `${config.restApiHost}/dewar/${dewar_id}/code?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ code }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить данные о сосуде Дьюара с id = ${dewar_id}.`)
            }

        },

        /**
         * Удалить коробку.
         * 
         * @param {Number} dewar_id - id сосуда Дьюара.
         */

        delete: async (dewar_id) => {

            let response = await fetch(
                `${config.restApiHost}/dewar/${dewar_id}?sid=${Cookie.get("sid")}`,
                {
                    method: "DELETE",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось удалить сосуд Дьюара с id = ${dewar_id}.`)
            }

        },

        /**
         * Получить список сосудов Дьюара.
         */

        list: async () => {

            let response = await fetch(
                `${config.restApiHost}/dewars?sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )            

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список сосудов Дьюара.`)
            }

        },

    },

    dewars_accounting: {

        /**
         * Создать запись учета сосудов Дьюара.
         * 
         * @param {*} user_id 
         * @param {*} dewar_id 
         */

        create: async (dewar_id, user_id, comment) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar?sid=${Cookie.get("sid")}`,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ dewar_id, user_id, comment }),
                }
            )          

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список сосудов Дьюара.`)
            }

        },

        /**
         * Получить список учёта сосудов Дьюара.
         * 
         * @param completion {String} - фильтр завершенности (0 - актив., 1 - заверш., 2 - все)
         * @param search {String} - строка поиска (код).
         */

        list: async (completion, search) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewars?completion=${encodeURIComponent(completion)}&search=${encodeURIComponent(search)}&sid=${Cookie.get("sid")}`,
                {
                    method: "GET",
                }
            )            

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось получить список сосудов Дьюара.`)
            }

        },

        /**
         * Удалит из списка учёта сосудов Дьюара.
         */

        delete: async (id) => {
            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}?sid=${Cookie.get("sid")}`,
                {
                    method: "DELETE",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось удалить запись с id = ${id}.`)
            }
        },

        /**
         * Изменить dewar_id для записи учёта сосудов Дьюара.
         * 
         * @param {Number} id - id записи учёта сосудов Дьюара.
         * @param {Number} dewar_id - id сосуда Дьюара.
         */

        update_dewar_id: async (id, dewar_id) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}/dewar_id?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ dewar_id }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить поле dewar_id для записи учёта сосудов Дьюара с id = ${id}.`)
            }

        },        

        /**
         * Изменить dewar_id для записи учёта сосудов Дьюара.
         * 
         * @param {Number} id - id записи учёта сосудов Дьюара.
         * @param {Number} user_id - id пользователя (Артиста).
         */

        update_user_id: async (id, user_id) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}/user_id?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ user_id }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить поле user_id для записи учёта сосудов Дьюара с id = ${id}.`)
            }

        },

        /**
         * Изменить completion для записи учёта сосудов Дьюара.
         * 
         * @param {Number} id - id записи учёта сосудов Дьюара.
         * @param {Number} completion - новое значение поля completion (0 - активно, 1 - завершено).
         */

        update_completion: async (id, completion) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}/completion?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ completion }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить поле completion для записи учёта сосудов Дьюара с id = ${id}.`)
            }

        },

        /**
         * Установить дату completion_date на текущий момент.
         * 
         * @param {Number} id - id записи учёта сосудов Дьюара.
         */

        update_completion_date: async (id, completion) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}/completion_date?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить поле completion для записи учёта сосудов Дьюара с id = ${id}.`)
            }

        },

        update_comment: async (id, comment) => {

            let response = await fetch(
                `${config.restApiHost}/accounting/dewar/${id}/comment?sid=${Cookie.get("sid")}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({ comment }),
                }
            )

            let json = await response.json()
            if (response.status == 200) {
                return json
            } else {
                throw new Error(`Не удалось обновить поле completion для записи учёта сосудов Дьюара с id = ${id}.`)
            }

        },

    }

}

export default api